import React, { useCallback, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { ACADEMY_TOPIC_TYPES } from 'data/academyTopicTypes';
import AcademyTopicSelect from 'components/AcademyTopicSelect';
import Field from 'components/Field';
import SectionHeading from 'components/SectionHeading';
import styles from './SelectClassPage.module.scss';

export default function SelectClassPage() {
  const [selectedClass, setSelectedClass] = useState();
  const navigate = useNavigate();

  const handleClassChange = useCallback(
    (option) => {
      setSelectedClass(option);
      navigate(String(option.value));
    },
    [navigate]
  );

  return (
    <>
      <SectionHeading
        title="EDIT CLASSES"
        subtitle="Edit classes using the following flow."
      />
      <div className={styles.pageContainer}>
        <Field
          label="Select Class"
          labelClassName="m-b-xs"
        >
          <AcademyTopicSelect
            type={ACADEMY_TOPIC_TYPES.template}
            onChange={handleClassChange}
            value={selectedClass}
          />
        </Field>
        <Outlet />
      </div>
    </>
  );
}
